 export  const ADD_NUMBER_SHOP_HOME = 'ADD_NUMBER_SHOP';
 export  const ADD_DETAIL_SHOP_DETALLE = 'ADD_DETAIL_SHOP_DETALLE';
 export  const ADD_DATA_RESPONSE = 'ADD_DATA_RESPONSE';
 export  const ADD_GLOBAL_STATE = 'ADD_GLOBAL_STATE';


